import { policyApi } from '@/core/api/policy'

export const { useGetPolicyQuery, useGetPoliciesQuery, useCreatePolicyMutation, useUpdatePolicyMutation, useDeletePolicyMutation } = policyApi
